import pino from 'pino';

/* eslint-disable no-console */
const logKeys = ['local', 'develop', 'production'];
if (!globalThis._njConsole) {
    globalThis._njConsole = Object.assign({}, globalThis.console);
}
const validateEnvironmentLevel = (level) => {
    if (!logKeys.includes(level)) {
        throw new Error(`log level should be one of theses values '${logKeys.join(',')}'`);
    }
};
const logLevel = (() => {
    if (typeof process != 'undefined' && process.env.LOG_LEVEL) {
        validateEnvironmentLevel(process.env.LOG_LEVEL);
        return process.env.LOG_LEVEL;
    }
    return 'production';
})();
const isFileLoggingEnabled = (() => {
    if (typeof process != 'undefined' && process.env.ENABLE_FILE_LOGGING) {
        return process.env.ENABLE_FILE_LOGGING === 'true';
    }
    return false;
})();
const logServiceName = (() => {
    if (typeof process != 'undefined' && process.env.SERVICE_NAME) {
        return process.env.SERVICE_NAME;
    }
    if (isFileLoggingEnabled)
        throw new Error('SERVICE_NAME environment variable is missing');
    return '';
})();
const createPinoLogger = ({ correlationId, requestId }) => {
    return pino({
        messageKey: 'message',
        mixin() {
            return { sn: logServiceName, cor: correlationId, reqId: requestId };
        },
        formatters: {
            level: (label) => {
                return {
                    level: label,
                };
            },
        },
    }, pino.destination({
        dest: './logs/app-json.log',
        sync: true,
        mkdir: true,
    }));
};
globalThis.njDebug = {
    level: logLevel,
    debug: console.debug.bind(console),
    info: console.info.bind(console),
    log: console.log.bind(console),
    warn: console.warn.bind(console),
    error: console.error.bind(console),
};
const initiateLogger = () => {
    ['debug', 'info', 'log', 'warn', 'error'].map((logMethod) => {
        const method = logMethod === 'log' ? 'info' : logMethod;
        globalThis.console[logMethod] = (...args) => {
            if (logLevel === 'production' && ['debug', 'log'].includes(logMethod))
                return;
            if (logLevel === 'develop' && ['debug'].includes(logMethod))
                return;
            if (isFileLoggingEnabled && typeof window === 'undefined') {
                const logger = createPinoLogger({});
                logger[method](JSON.stringify(args));
            }
            globalThis._njConsole[method](...args);
        };
        globalThis.njDebug[logMethod] = globalThis.console[logMethod].bind(globalThis.console);
    });
    _njConsole.log('Logger initiated');
};
const createLogger = ({ correlationId, requestId }) => {
    const logger = Object.assign(Object.assign({}, globalThis._njConsole), { level: logLevel });
    ['debug', 'info', 'log', 'warn', 'error'].map((logMethod) => {
        const method = logMethod === 'log' ? 'info' : logMethod;
        logger[logMethod] = (...args) => {
            if (logLevel === 'production' && ['debug', 'log'].includes(logMethod))
                return;
            if (logLevel === 'develop' && ['debug'].includes(logMethod))
                return;
            if (isFileLoggingEnabled && typeof window === 'undefined') {
                const localLogger = createPinoLogger({ correlationId, requestId });
                localLogger[method](JSON.stringify(args));
            }
            globalThis._njConsole[method](...[correlationId, requestId, ...args]);
        };
    });
    return logger;
};

export { createLogger, initiateLogger };
